var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_2043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 0.928589C5.60918 0.928589 0.428467 6.1093 0.428467 12.5C0.428467 18.8907 5.60918 24.0714 11.9999 24.0714C18.3906 24.0714 23.5713 18.8907 23.5713 12.5C23.5713 6.1093 18.3906 0.928589 11.9999 0.928589Z",
    fill: "#00CF6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0792 7.49439C17.4768 7.93267 17.4438 8.61025 17.0056 9.00783C15.6633 10.2254 14.7392 11.2435 13.9732 12.4391C13.203 13.6413 12.5634 15.0685 11.843 17.1379C11.7208 17.489 11.4253 17.7517 11.0624 17.8319C10.6994 17.9121 10.3207 17.7985 10.0619 17.5316L6.94507 14.3173C6.53314 13.8925 6.54358 13.2142 6.96838 12.8022C7.39318 12.3903 8.07149 12.4007 8.48343 12.8255L10.4155 14.818C10.9576 13.4436 11.5112 12.3096 12.1689 11.2831C13.0719 9.87361 14.1417 8.71258 15.5658 7.42069C16.0041 7.02312 16.6817 7.05612 17.0792 7.49439Z",
    fill: "white",
    fillOpacity: 0.95
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_2043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOn);
export default __webpack_public_path__ + "static/media/check-on.ef296292b975a102465bac471c5e14db.svg";
export { ForwardRef as ReactComponent };